import {
    Redirect,
    Route,
    Switch,
    useHistory,
    useLocation,
    useRouteMatch,
} from 'react-router';
import { ImageSelectorStore } from '../../state/reducers/ImageSelectorReducer';
import { Faq } from '../screens/Faq';
import { CurrentConsumerStore } from '../screens/Home/NewHome/reducer';
import { ModuleSelector } from '../../components/ModuleSelector/ModuleSelector';
import { EULA } from '../screens/Mundu/eula';
import { Licences } from '../screens/Mundu/licences';
import { Privacy } from '../screens/Mundu/privacy';
import { MyProfile } from '../screens/MyProfile';
import { NewConsumer } from '../screens/NewConsumer';
// import { CreateNewVideo } from '../screens/NewVideo';
import { SessionFormStore } from '../screens/NewVideo/SessionFormState/store';
import { Users } from '../screens/Users';
import { UserProfile } from '../screens/Users/Profile';
import { Home } from '../screens/Home';
import { NewCreator } from '../screens/NewCreator';
import { NewNextOfKin } from '../screens/NewNextOfKin';
import { ImageUpload } from '../screens/ImageUpload';
import { ImageUploadStore } from '../screens/ImageUpload/state';
import AppRoute from './AppRoute';
import { UserRole } from 'src/domain/user';
import { NotificationProvider } from 'src/components/Notification/NotificationProvider';
// import { UploadHistory } from '../screens/NextOfKin';
import { Login } from '../screens/login';
import { ResetPassword } from '../screens/login/ResetPassword';
import { ActivateAccount } from '../screens/login/ActivateAccount';
import { NotFound } from '../screens/NotFound';
import { Creators } from '../screens/Creators';
import { Admin } from '../screens/Admin';
import { CreateAdminForm, OrganizationForm } from '../screens/Admin/components';

import { OrgInfo } from '../screens/Admin/OrgInfo';
import { EditOrganization } from '../screens/Admin/EditOrganization';
import { Messages } from '../screens/Messages';
import { CreateMessagePage } from '../screens/Messages/CreateMessagePage';
import { CalendarScreen } from '../screens/Calendar';
import { CalendarSettings } from '../screens/Calendar/Settings';
import { OrganizationSettings } from '../screens/OrganizationSettings';
import { AppContent } from '../screens/AppContent';
import { AppContentSettings } from '../screens/AppContent/Settings';
import { InfoScreen } from '../screens/InfoScreen';
import { InfoScreenSettings } from '../screens/InfoScreen/Settings';
import { PublicInfoScreen } from '../screens/InfoScreen/PublicInfoScreen';
import { AnalyticsScreen } from '../screens/Analytics';
import { AnalyticsSettings } from '../screens/Analytics/Settings';
import { ModuleEntryRedirect } from '../screens/components/ModuleEntryRedirect';
import { useWebPushRegistration } from '../hooks/useWebPushRegistration';
import { WebPushPermissionPrompt } from 'src/components/Notification/WebPushPermissionPrompt';
import { OrganizationModuleType } from 'src/domain/organization';

const CalendarModuleEntry = () => (
    <ModuleEntryRedirect
        moduleType={OrganizationModuleType.calendar}
        settingsPath="/app/calendar/settings"
    >
        <CalendarScreen />
    </ModuleEntryRedirect>
);

const InfoScreenModuleEntry = () => (
    <ModuleEntryRedirect
        moduleType={OrganizationModuleType.infoScreen}
        settingsPath="/app/info-screen/settings"
    >
        <InfoScreen />
    </ModuleEntryRedirect>
);

const AppContentModuleEntry = () => (
    <ModuleEntryRedirect
        moduleType={OrganizationModuleType.appContent}
        settingsPath="/app/documents/settings"
    >
        <AppContent />
    </ModuleEntryRedirect>
);

/**
 * Mundu web app routes.
 */
const appRoutes = () => (
    <Switch>
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/home"
            component={Home}
        />
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/messages/create"
            component={CreateMessagePage}
        />
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/messages"
            component={Messages}
        />
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/calendar"
            component={CalendarModuleEntry}
        />
        <AppRoute
            exact
            roles={[UserRole.organization]}
            path="/app/calendar/settings"
            component={CalendarSettings}
        />
        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            exact
            path="/app/faq"
            component={Faq}
        />
        <AppRoute
            roles={[
                UserRole.nextOfKin,
                UserRole.organization,
                UserRole.creator,
                UserRole.organizationB2C,
            ]}
            allowAdmin
            exact
            path="/app/my-profile"
            component={MyProfile}
        />
        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            exact
            path="/app/users"
            component={Users}
        />
        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            exact
            path="/app/users/new"
            component={NewConsumer}
        />
        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/users/profile/:id"
            component={UserProfile}
        />
        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/nextofkins/new"
            component={NewNextOfKin}
        />

        {/* <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/new-video"
            component={CreateNewVideo}
        />
        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/videos/edit"
        /> */}

        <AppRoute
            exact
            roles={[
                UserRole.organization,
                UserRole.organizationB2C,
                UserRole.creator,
            ]}
            path="/app/creators"
            component={Creators}
        />
        <AppRoute
            roles={[
                UserRole.organization,
                UserRole.organizationB2C,
                UserRole.creator,
            ]}
            path="/app/creators/new"
            component={NewCreator}
        />

        <AppRoute
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/image-upload"
            component={ImageUpload}
        />

        {/* <AppRoute
            roles={[UserRole.nextOfKin]}
            path="/app/nextofkin-image-list"
            component={UploadHistory}
        />
        <AppRoute
            roles={[UserRole.nextOfKin]}
            path="/app/nextofkin-image-upload"
            component={ImageUpload}
        /> */}
        <AppRoute
            roles={[UserRole.nextOfKin]}
            path="/app/nextofkin-profile"
            component={MyProfile}
        />
        <AppRoute
            exact
            allowAdmin
            roles={[UserRole.organization, UserRole.organizationB2C]}
            path="/app/organization"
            component={OrganizationSettings}
        />
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/documents"
            component={AppContentModuleEntry}
        />
        <AppRoute
            exact
            roles={[UserRole.organization]}
            path="/app/documents/settings"
            component={AppContentSettings}
        />
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/info-screen"
            component={InfoScreenModuleEntry}
        />
        <AppRoute
            exact
            roles={[UserRole.organization]}
            path="/app/info-screen/settings"
            component={InfoScreenSettings}
        />
        <AppRoute
            exact
            roles={[
                UserRole.creator,
                UserRole.organization,
                UserRole.organizationB2C,
            ]}
            path="/app/analytics"
            component={AnalyticsScreen}
        />
        <AppRoute
            exact
            roles={[UserRole.organization]}
            path="/app/analytics/settings"
            component={AnalyticsSettings}
        />
        <AppRoute adminOnly exact path="/app/admin" component={Admin} />
        <AppRoute
            adminOnly
            path="/app/admin/organization/:id"
            component={OrgInfo}
        />
        <AppRoute
            adminOnly
            path="/app/admin/organizations/:id/edit"
            component={EditOrganization}
        />
        <AppRoute
            adminOnly
            path="/app/admin/organizations/new"
            component={OrganizationForm}
        />
        <AppRoute
            adminOnly
            path="/app/admin/admins/new"
            component={CreateAdminForm}
        />

        <Route path="*" component={NotFound} />
    </Switch>
);
const App = () => {
    const history = useHistory();
    const location = useLocation();
    const match = useRouteMatch();
    return (
        <ModuleSelector history={history} location={location} match={match}>
            {appRoutes}
        </ModuleSelector>
    );
};

const Routes = () => {
    const webPushRegistration = useWebPushRegistration();

    return (
        <NotificationProvider>
            <WebPushPermissionPrompt {...webPushRegistration} />
            <Switch>
                <Redirect exact from="/" to="/login" />
                <Redirect from="/kommersnart" to="/login" />
                <Redirect from="/contact" to="/login" />
                <Redirect from="/tippetue" to="/login" />
                <Redirect from="/news" to="/login" />
                <Route path={'/privacy'} component={Privacy} />
                <Route path={'/eula'} component={EULA} />
                <Route path={'/licences'} component={Licences} />
                <Route path={'/login'} component={Login} />
                <Route path={'/reset-password'} component={ResetPassword} />
                <Route path={'/activate'} component={ActivateAccount} />
                <Route
                    path={'/info-screen/:token'}
                    component={PublicInfoScreen}
                />

                <ImageUploadStore>
                    <CurrentConsumerStore>
                        <SessionFormStore>
                            <ImageSelectorStore>
                                <AppRoute
                                    path={'/app'}
                                    requireAuth
                                    component={App}
                                />
                            </ImageSelectorStore>
                        </SessionFormStore>
                    </CurrentConsumerStore>
                </ImageUploadStore>
                <Route path="*" component={NotFound} />
            </Switch>
        </NotificationProvider>
    );
};

export default Routes;
